export default "__VITE_ASSET__09bfd62b__"